function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2444_93)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.03915 13.4575L7.39462 14.8765H1.29501L1.57138 13.4575H7.03915Z",
  fill: "#F15F67",
  stroke: "#F15F67",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.75806 1.73096L7.76001 1.73291L10.0374 4.00439L9.33716 4.37842C9.29501 4.40088 9.25602 4.42896 9.22192 4.4624L4.73755 8.86279C4.72139 8.87865 4.70646 8.89572 4.69263 8.91357L4.65454 8.97119L4.04614 10.0298L1.9563 7.96924L1.95435 7.96729L1.48462 7.50732L2.35669 7.09033C2.40735 7.06603 2.45361 7.03331 2.49341 6.99365L7.05005 2.44482C7.09236 2.40255 7.12679 2.35276 7.15161 2.29834L7.51978 1.48975L7.75806 1.73096Z",
  fill: "#F15F67",
  stroke: "#F15F67",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-1_2444_93",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.67597 6L14.5925 11.9318C14.8858 12.2361 15.0482 12.6437 15.0446 13.0669C15.041 13.49 14.8717 13.8948 14.5733 14.1941C14.2749 14.4933 13.8711 14.663 13.4491 14.6666C13.027 14.6702 12.6205 14.5074 12.317 14.2133L6.37796 8.25893"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.67597 6L14.5925 11.9318C14.8858 12.2361 15.0482 12.6437 15.0446 13.0669C15.041 13.49 14.8717 13.8948 14.5733 14.1941C14.2749 14.4933 13.8711 14.663 13.4491 14.6666C13.027 14.6702 12.6205 14.5074 12.317 14.2133L6.37796 8.25893",
  fill: "#F15F67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.38399 5.29381C8.99397 4.90278 8.36081 4.90196 7.96978 5.29198C7.57875 5.682 7.57794 6.31517 7.96796 6.70619L8.67597 6L9.38399 5.29381ZM14.5925 11.9318L15.3124 11.2378C15.3085 11.2337 15.3045 11.2296 15.3005 11.2256L14.5925 11.9318ZM12.317 14.2133L11.609 14.9195C11.613 14.9235 11.617 14.9275 11.6211 14.9314L12.317 14.2133ZM7.08598 7.55273C6.69596 7.16171 6.06279 7.16089 5.67177 7.55091C5.28074 7.94093 5.27992 8.57409 5.66994 8.96512L6.37796 8.25893L7.08598 7.55273ZM8.67597 6L7.96796 6.70619L13.8845 12.638L14.5925 11.9318L15.3005 11.2256L9.38399 5.29381L8.67597 6ZM14.5925 11.9318L13.8725 12.6258C13.9839 12.7413 14.046 12.8966 14.0446 13.0584L15.0446 13.0669L16.0445 13.0754C16.0503 12.3908 15.7877 11.7308 15.3124 11.2378L14.5925 11.9318ZM15.0446 13.0669L14.0446 13.0584C14.0432 13.2201 13.9785 13.3743 13.8652 13.4879L14.5733 14.1941L15.2813 14.9002C15.7649 14.4154 16.0387 13.7599 16.0445 13.0754L15.0446 13.0669ZM14.5733 14.1941L13.8652 13.4879C13.7521 13.6014 13.5995 13.6653 13.4406 13.6666L13.4491 14.6666L13.4576 15.6666C14.1428 15.6607 14.7977 15.3852 15.2813 14.9002L14.5733 14.1941ZM13.4491 14.6666L13.4406 13.6666C13.2816 13.668 13.128 13.6067 13.0129 13.4952L12.317 14.2133L11.6211 14.9314C12.113 15.4081 12.7725 15.6724 13.4576 15.6666L13.4491 14.6666ZM12.317 14.2133L13.025 13.5071L7.08598 7.55273L6.37796 8.25893L5.66994 8.96512L11.609 14.9195L12.317 14.2133Z",
  fill: "#F15F67",
  mask: "url(#path-3-inside-1_2444_93)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2444_93"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.4226,
  height: 16,
  fill: "white"
})));

var SvgMartilloRed = function SvgMartilloRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMartilloRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/martillo-red.f30fac0d.svg";
export { ForwardRef as ReactComponent };